<template>
  <div>
    <el-dialog title="新增外采订单" :visible.sync="dialogVisible" width="780px" :close-on-click-modal="false"
               @close="closeDialog">
      <div class="form_box">
        <div class="form_item flex_box_between">
          <div class="flex_box" :class="form.regionId === 1 ? 'long' : ''">
            <div class="required form_title">区域</div>
            <el-select v-model="form.regionId" @change="regionChange">
              <el-option :value="1" label="国内"/>
              <el-option :value="2" label="海外"/>
            </el-select>
          </div>
          <div class="flex_box" v-show="form.regionId === 2">
            <div class="form_title">国家</div>
            <el-select v-model="form.countryCode" filterable clearable>
              <el-option value="CN" label="中国" v-show="form.regionId === 1"/>
              <el-option-group v-for="group in countryList" :key="group.label" :label="group.label"
                               v-show="form.regionId === 2">
                <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
          </div>
        </div>
        <div class="form_item flex_box" v-if="form.regionId === 1">
          <div class="required form_title">渠道</div>
          <div>
            <el-radio-group v-model="form.supplierId" @change="clearHotelName">
              <el-radio :label="67">美团</el-radio>
              <el-radio :label="32">飞猪</el-radio>
              <el-radio :label="27">携程</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="form_item flex_box">
          <div class="required form_title">酒店名称</div>
          <div class="hotel_name_box">
            <div class="hotel_name_input">
              <el-input ref="hotel_input" v-model="form.hotelName" placeholder="请输入酒店名称" @blur="searchBlur"
                        @focus="searchFocus"
                        @input="searchHotel" :disabled="!!form.sHotelId || !!form.hotelCode"/>
              <i class="el-icon-circle-close" v-show="form.hotelName" @click="clearHotelName"/>
            </div>
            <div class="hotel_search_result" v-show="form.hotelName && showResultPlane" @mousedown.capture.prevent.stop>
              <div class="hotel_item flex_box_between" v-for="item in hotelResultList" :key="item.sHotelId"
                   @click="selectHotel(item)">
                <div class="flex_box">
                  <div v-html="item.hotelNameCn"></div>
                  <div v-html="item.hotelName" v-if="item.hotelNameCn !== item.hotelName"></div>
                </div>
                <div style="text-align: right">
                  <span>{{ item.city }}</span>
                  <span v-show="form.regionId === 2">{{ item.country }}</span>
                </div>
              </div>
              <div style="color: red;margin-top: 10px;cursor: pointer" @click="clickNoHotel" v-if="!isSearch">
                <span>无符合酒店？请人工录入酒店名称</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form_item flex_box">
          <div class="required form_title">酒店地址</div>
          <div>
            <el-input v-model="form.address" placeholder="请输入酒店地址" :disabled="!!form.sHotelId || !!form.hotelCode"/>
          </div>
        </div>
        <div class="form_item flex_box" v-if="form.regionId === 2 || !roomList.length || (!form.hotelCode && !form.sHotelId)">
          <div class="required form_title">房型名称</div>
          <div>
            <el-input v-model="form.roomName" placeholder="请输入房型名称"/>
          </div>
        </div>
        <div class="form_item" v-else>
          <div class="flex_box long">
            <div class="required form_title">房型名称</div>
            <div>
              <el-select v-model="form.roomId" placeholder="请选择房型">
                <el-option v-for="item in roomList" :key="item.roomId" :value="item.roomId" :label="item.roomName"/>
              </el-select>
            </div>
          </div>
        </div>
        <div class="form_item flex_box">
          <div class="required form_title">酒店电话</div>
          <div>
            <el-input v-model="form.hotelPhone" placeholder="请输入酒店电话" :disabled="!!form.sHotelId || !!form.hotelCode"/>
          </div>
        </div>
        <div class="border__"></div>
        <div class="form_item flex_box">
          <div class="required form_title">贵司订单号</div>
          <div>
            <el-input v-model="form.channelOrderNum" placeholder="可以使用此单号在订单管理中查看处理进度和进行售后"/>
          </div>
        </div>
        <div class="form_item flex_box_between">
          <div class="flex_box">
            <div class="required form_title">人数</div>
            <el-select v-model="form.adultCount">
              <el-option v-for="item in 4" :value="item" :label="`${item}成人`" :key="item"/>
            </el-select>
          </div>
          <div class="flex_box">
            <div class="required form_title">房间数</div>
            <el-select v-model="form.roomCount">
              <el-option v-for="item in 9" :value="item" :label="`${item}间房`" :key="item"/>
            </el-select>
          </div>
        </div>
        <div class="form_item flex_box_between">
          <div class="flex_box">
            <div class="required form_title">餐食</div>
            <el-select v-model="form.mealCount">
              <el-option :value="0" label="无早"/>
              <el-option :value="1" label="单早"/>
              <el-option :value="2" label="双早"/>
            </el-select>
          </div>
          <div class="flex_box">
            <div class="required form_title">
              <el-tooltip class="item" effect="dark" content="为确保服务质量，系统仅接受入住当天 [22:50] 前的预订申请"
                          placement="top" v-if="checkOverTime()">
                <span>入离日期<i class="el-icon-question"/></span>
              </el-tooltip>
              <span v-else>入离日期</span>
            </div>
            <el-date-picker v-model="dateRange" type="daterange" range-separator="-" start-placeholder="入住"
                            end-placeholder="离店" :picker-options="noOldDate" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>
        <div class="form_item flex_box">
          <div class="required form_title">入住人</div>
          <div>
            <el-input v-model="form.guestNames"
                      placeholder="姓和名之间用/符号分隔，多个入住人请用|符号分隔，如张/三|Doe/John"/>
          </div>
        </div>
        <div class="form_item flex_box">
          <div class="required form_title">总价格</div>
          <div>
            <div>
              <el-input v-model="form.totalPrice" placeholder="请输入"/>
            </div>
          </div>
        </div>
        <div class="form_item flex_normal">
          <div class="form_title">特殊备注</div>
          <div>
            <el-input v-model="form.specialRequest" placeholder="请输入" type="textarea" :rows="4"/>
          </div>
        </div>
        <div class="form_item left">
          <div class="form_title" style="text-align: right">上传图片</div>
          <div style="width: 625px !important;">
            <el-upload action="#" list-type="picture-card" :limit="9" accept="image/bmp,image/jpg,image/png"
                       :auto-upload="false" :on-exceed="handleExceed" :file-list="fileList" :on-change="fileChange"
                       :on-remove="fileRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="订单支付确认" :visible.sync="showConfirmDialog" width="550px" :close-on-click-modal="false">
      <div>
        <div class="flex_normal" style="color: #f57070;padding-bottom: 25px;column-gap: 16px">
          <i class="el-icon-warning-outline"></i>
          <span>订单满足预订需求时将直接确认，使用账户余额扣款，如需终止预订，需与科坦客服联系确认。</span>
        </div>
        <div class="border__"></div>
        <div style="margin-top: 25px">
          <div class="info_item" style="font-weight: bolder;color: #000000">{{ form.hotelName }}</div>
          <div class="info_item">地址：{{ form.address }}</div>
          <div class="info_item">电话：{{ form.hotelPhone }}</div>
          <div class="info_item">房型间数：{{ form.roomName }}-{{ form.roomCount }}间</div>
          <div class="info_item">入离时间：{{ form.checkIn }}至{{ form.checkOut }} {{ nightCount() }}</div>
          <div class="info_item">入住人：{{ form.guestNames }}</div>
          <div class="info_item">订单号：{{ form.channelOrderNum }}</div>
        </div>
      </div>

      <div style="text-align: right">
        <span>订单总金额:</span>
        <span style="color: #1e50f0;font-size: 15px">CNY {{ form.totalPrice }}</span>
      </div>
      <div style="text-align: center;margin: 20px 0">
        <el-button type="primary" @click="createExternalOrder" :loading="confirmLoading">
          额度支付CNY {{ form.totalPrice }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OpenApi from '../../../newWebsite/main/openApi.vue'

export default {
  name: 'PurchaseDialog',
  components: {OpenApi},
  data () {
    return {
      dialogVisible: false,
      form: {
        regionId: 1,
        adultCount: 2,
        roomCount: 1,
        mealCount: 0,
        supplierId: 67
      },
      dateRange: [],
      noOldDate: {
        disabledDate (time) {
          return time.getTime() + 82200000 < Date.now()
        }
      },
      countryList: [{
        label: '常用国家',
        options: [{
          value: 'AU',
          label: '澳大利亚'
        }, {
          value: 'ES',
          label: '西班牙'
        }, {
          value: 'GB',
          label: '英国'
        }, {
          value: 'JP',
          label: '日本'
        }, {
          value: 'KR',
          label: '韩国'
        }, {
          value: 'US',
          label: '美国'
        }]
      }, {
        label: '全部国家',
        options: []
      }],
      showResultPlane: false,
      hotelResultList: [],
      showConfirmDialog: false,
      confirmLoading: false,
      roomList: [],
      fileList: [],
      isSearch: true
    }
  },
  methods: {
    async init () {
      if (!this.countryList[1].options.length) {
        await this.getAllCountries()
      }
      this.dialogVisible = true
    },
    async getAllCountries () {
      const {data: result} = await this.$http.get('/mini/getAllCountries')
      if (result.code !== 200) return this.$message.error(result.message)
      this.countryList = [{
        label: '常用国家',
        options: [{
          value: 'AU',
          label: '澳大利亚'
        }, {
          value: 'ES',
          label: '西班牙'
        }, {
          value: 'GB',
          label: '英国'
        }, {
          value: 'JP',
          label: '日本'
        }, {
          value: 'KR',
          label: '韩国'
        }, {
          value: 'US',
          label: '美国'
        }]
      }, {
        label: '全部国家',
        options: []
      }]
      let filterCountryCode = this.countryList[0].options.map(item => item.value)
      result.data.forEach(item => {
        if (!filterCountryCode.includes(item.countryCode) && item.countryCode !== 'CN') {
          this.countryList[1].options.push({
            label: item.nameCN,
            value: item.countryCode
          })
        }
      })
    },
    regionChange () {
      this.$set(this.form, 'countryCode', '')
      this.$set(this.form, 'sHotelId', '')
      this.hotelResultList = []
    },
    searchBlur () {
      this.showResultPlane = false
    },
    searchFocus () {
      this.showResultPlane = true
    },
    clearHotelName () {
      this.$set(this.form, 'sHotelId', '')
      this.$set(this.form, 'hotelName', '')
      this.$set(this.form, 'address', '')
      this.$set(this.form, 'hotelPhone', '')
      this.$set(this.form, 'roomId', '')
      this.$set(this.form, 'roomName', '')
      this.$set(this.form, 'hotelCode', '')
    },
    searchHotel (e) {
      this.$set(this.form, 'sHotelId', '')
      this.isSearch = true
      if (!e) return this.showResultPlane = false
      this.$common.debounce(async () => {
        let req = {
          keyword: e,
          regionId: this.form.regionId,
          supplierId: this.form.supplierId
        }
        let reqHeader = {
          accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
        }
        if (this.form.countryCode) {
          req.countryCode = this.form.countryCode
        }
        const {data: result} = await this.$http.post('/mini/searchHotelByName', req, {headers: reqHeader})
        this.isSearch = false
        if (result.code !== 200) return this.$message.error(result.message)
        this.hotelResultList = result.data
        this.showResultPlane = true
      }, 300)
    },
    async selectHotel (hotel) {
      this.$set(this.form, 'sHotelId', hotel.hotelId)
      let hotelName = this.form.regionId === 1 ? hotel.sourceHotelNameCn : `${hotel.sourceHotelNameCn} ${hotel.sourceHotelName === hotel.sourceHotelNameCn ? '' : hotel.sourceHotelName}`.trim()
      let address = this.form.regionId === 1 ? hotel.addressCn : `${hotel.addressCn} ${hotel.address === hotel.addressCn ? '' : hotel.address}`.trim()
      this.$set(this.form, 'hotelName', hotelName)
      this.$set(this.form, 'address', address)
      this.$set(this.form, 'hotelPhone', hotel.phone)
      if (this.form.regionId === 1) {
        this.$set(this.form, 'hotelCode', hotel.hotelCode)
      }
      await this.searchExternalRoom(hotel)
      this.$refs['hotel_input'].blur()
      this.showResultPlane = false
    },
    async searchExternalRoom (hotel) {
      this.roomList = []
      let reqHeader = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      let req = {
        regionId: hotel.regionId,
        sHotelId: hotel.hotelId,
        hotelCode: hotel.hotelCode,
        supplierId: hotel.supplierId
      }
      const {data: result} = await this.$http.post('/mini/searchExternalRoom', req, {headers: reqHeader})
      if (result.code !== 200) return this.roomList = []
      this.roomList = result.data
    },
    clickNoHotel () {
      this.$refs['hotel_input'].blur()
      this.showResultPlane = false
    },
    checkTime () {
      let checkIn = new Date(this.dateRange[0]).getTime() + 53400000
      let nowDate = Date.now()
      return nowDate > checkIn
    },
    checkOverTime () {
      let today = new Date().Format('yyyy-MM-dd')
      let todayTenClock = new Date(new Date(today).getTime() + 53400000).getTime()
      let nowDate = Date.now()
      return todayTenClock < nowDate
    },
    confirm () {
      if (!this.form.hotelName) return this.$message.warning('请填写酒店名称')
      if (!this.form.address) return this.$message.warning('请填写酒店地址')
      if (this.form.regionId === 1) {
        if (!this.form.roomId && !this.form.roomName) return this.$message.warning('请选择房型')
      } else {
        if (!this.form.roomName) return this.$message.warning('请填写房型名称')
      }
      if (!this.form.hotelPhone) return this.$message.warning('请填写酒店电话')
      if (!this.form.channelOrderNum) return this.$message.warning('请填写订单号')
      if (!this.dateRange || !this.dateRange.length) return this.$message.warning('请选择入离时间')
      if (this.dateRange[0] === this.dateRange[1]) return this.$message.warning('入离时间不允许相同')
      if (!this.form.guestNames) return this.$message.warning('请填写入住人')
      if (!this.form.totalPrice) return this.$message.warning('请填写总价格')
      if (isNaN(Number(this.form.totalPrice))) return this.$message.warning('总价格填写错误')
      if (Number(this.form.totalPrice) <= 0) return this.$message.warning('总价格填写错误')
      this.$set(this.form, 'checkIn', this.dateRange[0])
      this.$set(this.form, 'checkOut', this.dateRange[1])
      if (this.form.regionId === 1) {
        let room = this.roomList.find(room => room.roomId === this.form.roomId)
        this.form = {...this.form, ...room}
      }
      if (this.checkTime()) return this.$message.warning('为确保服务质量，系统仅接受入住当天 [22:50] 前的预订申请')
      this.showConfirmDialog = true
    },
    async createExternalOrder () {
      if (this.checkTime()) return this.$message.warning('为确保服务质量，系统仅接受入住当天 [22:50] 前的预订申请')
      this.confirmLoading = true
      let reqHeader = {
        accessToken: this.$common.isLogin() ? JSON.parse(this.$common.isLogin()).token : ''
      }
      let req = new FormData()
      req.append('requestJSON', JSON.stringify(this.form))
      this.fileList.forEach(file => {
        req.append('files', file.raw)
      })
      const {data: result} = await this.$http.post('/mini/createExternalOrder', req, {headers: reqHeader})
      this.confirmLoading = false
      if (result.code !== 200) return this.$message.error(result.message)
      this.showConfirmDialog = false
      this.dialogVisible = false
      this.$emit('createSuccess')
    },
    nightCount () {
      if (!this.form.checkIn || !this.form.checkOut) return ''
      const parseDate = str => new Date(str.replace(/-/g, '/'))
      const start = parseDate(this.form.checkIn).setHours(12, 0, 0, 0) // 设置到中午避免夏令时影响
      const end = parseDate(this.form.checkOut).setHours(12, 0, 0, 0)
      return Math.round((end - start) / (24 * 60 * 60 * 1000)) + '晚'
    },
    closeDialog () {
      this.form = {
        regionId: 1,
        adultCount: 2,
        roomCount: 1,
        mealCount: 0,
        supplierId: 67
      }
      this.dateRange = []
      this.roomList = []
      this.fileList = []
    },
    handleExceed () {
      this.$message.warning('仅允许上传9张图片')
    },
    fileChange (file, fileList) {
      this.fileList = fileList
    },
    fileRemove (file, fileList) {
      this.fileList = fileList
    }
  }
}
</script>

<style scoped lang="less">
.form_box {
  height: 700px;
  overflow: auto;
  border-top: 1px solid #f3f3f3;
  padding-top: 15px;
  padding-right: 10px;

  .form_item {
    margin-bottom: 15px;
    text-align: right;

    &.left {
      display: flex;
      column-gap: 8px;
      text-align: left;
    }

    .long {
      & /deep/ .el-select .el-input__inner {
        width: 625px;
      }
    }

    & /deep/ .el-input__inner {
      width: 625px;
    }

    & /deep/ .el-textarea__inner {
      width: 625px;
    }

    & /deep/ .el-select .el-input__inner {
      width: 255px;
    }

    & /deep/ .el-range-editor.el-input__inner {
      width: 255px !important;
    }

    .form_title {
      width: 90px !important;
    }

    & /deep/ .el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }

    & /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 100px;
      height: 100px;
    }
  }
}

.border__ {
  height: 1px;
  border-bottom: 1px solid #d7d7d7;
  margin-bottom: 15px;
}

.flex_box {
  display: flex;
  align-items: center;
  gap: 8px;
}

.flex_normal {
  display: flex;
  justify-content: space-between;
  //gap: 16px;
}

.flex_box_between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.required::before {
  content: '*';
  margin-right: 8rpx;
  color: red;
}

.hotel_name_box {
  position: relative;

  .hotel_name_input {
    position: relative;

    .el-icon-circle-close {
      position: absolute;
      right: 20px;
      top: 14px;
      cursor: pointer;
    }
  }

  .hotel_search_result {
    position: absolute;
    background-color: #FFFFFF;
    max-height: 410px;
    overflow: scroll;
    width: 622px;
    z-index: 2;
    box-shadow: 1px 1px 4px 1px #a0a0a0;
    border-top: none;
    text-align: left;
    padding: 10px;

    .hotel_item {
      font-size: 13px;
      padding: 15px 0;
      border-bottom: 1px solid #a0a0a0;
      cursor: pointer;
    }
  }
}

.info_item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/components/PurchaseDialog.vue